<div class="booble-backdrop-drawer-right">
  <div class="drawer-rtl-in">
    <div class="drawer-content-lg">
      <div class="row padding-left-32 drawer-header">
        <div class="col-md-11">
          <div class="d-flex flex-column">
            <h2 class="title-modal">Informações a tesouraria</h2>
            <p class="p-text-grey-scale-dark mg-bottom-24">
              Confira as informações da ordem para inclusão das informações da
              tesouraria.
            </p>
          </div>
        </div>

        <div class="col-md-1 d-flex justify-content-end mg-top-10">
          <div (click)="closeModal()" class="close-icon tappable">
            <img src="assets/image/close-modal-icon.svg" />
          </div>
        </div>
      </div>
      <div class="modal-dialog-scrollable-general">
        <div class="modal-body h-100">
          <div class="">
            <div *ngIf="boobleModalData?.remmitanceType == 'INBOUND'" class="box-order">
              <div class="row">
                <div class="col-md-6">
                  <span class="p-text-grey">
                    Número:&nbsp;
                    <span class="value">{{ this.boobleModalData?.id }}
                    </span></span><br /><br />
                  <span class="p-text-grey">
                    Valor recebido:&nbsp;
                    <span class="value">{{ this.boobleModalData?.currency?.description }}
                      {{
                      this.boobleModalData?.conciliations[0].amountReceived
                      }}</span></span><br /><br />
                  <span class="p-text-grey">
                    Banco da moeda:&nbsp;
                    <span class="value">{{ this.boobleModalData?.conciliations[0].bankName }}
                    </span></span><br /><br />
                  <span class="p-text-grey">Pagamento no exterior: &nbsp;
                    <span class="value">{{
                      this.boobleModalData?.conciliations[0]?.paymentDate
                      | date : "dd/MM/yyyy"
                      }}</span></span><br /><br />
                </div>

                <div *ngIf="this.boobleModalData?.finality?.description" class="col-md-6">
                  <span class="p-text-grey">Moeda: &nbsp;
                    <span class="value">
                      <mat-icon [svgIcon]="this.currency?.icon"></mat-icon><span class="ml-2">{{
                        this.currency?.description
                        }}</span>
                    </span></span><br /><br />

                  <span class="p-text-grey">
                    Finalidade:&nbsp;
                    <span class="value">{{ this.boobleModalData?.finality?.description }}
                    </span></span><br /><br />
                  <span class="p-text-grey">
                    Valor em reais:&nbsp;
                    <span class="value-bold">
                      {{ this.boobleModalData?.quotations[0]?.amountMN | brl }}
                    </span></span><br /><br />
                </div>
              </div>

              <div class="d-flex justify-content-center" *ngIf="showReadMore">
                <span (click)="
                    !showReadMore
                      ? (showReadMore = true)
                      : (showReadMore = false)
                  " class="view-more">{{ showReadMore ? "Ver mais " : "Ver menos" }}</span>
              </div>
              <div [class]="showReadMore ? 'd-none' : 'd-block'">
                <h4 class="mg-bottom-32 mg-top-8 title-generic">
                  Dados do cliente
                </h4>
                <div *ngIf="this.boobleModalData?.tipoPessoa == 'PJ'" class="row">
                  <div class="col-md-6">
                    <span class="p-text-grey">
                      Nome:&nbsp;
                      <span class="value">{{
                        this.boobleModalData?.corporateAccount?.companyName
                        }}
                      </span></span><br /><br />
                    <span class="p-text-grey">CNPJ: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.corporateAccount?.cnpj
                        | mask : "AA.AAA.AAA/AAAA-00"
                        }}</span></span><br /><br />
                    <span class="p-text-grey">Banco: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.corporateAccount?.bankAccount
                        ?.name
                        }}</span></span><br /><br />
                    <span class="p-text-grey">Conta: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.corporateAccount?.bankAccount
                        ?.number
                        }}</span></span><br /><br />
                  </div>
                  <div class="col-md-6">
                    <span class="p-text-grey">
                      Telefone:&nbsp;
                      <span class="value">{{
                        this.boobleModalData?.corporateAccount?.users[0]
                        ?.phoneNumber
                        | mask : "(00) 00000-0000 || (00) 0000-0000"
                        }}
                      </span></span><br /><br />
                    <span class="p-text-grey">Agência: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.corporateAccount?.bankAccount
                        ?.agency
                        }}</span></span><br /><br />
                    <span class="p-text-grey">
                      Faturamento anual:&nbsp;
                      <span class="value">
                        {{
                        this.boobleModalData?.corporateAccount?.annualBilling
                        | brl
                        }}
                      </span></span><br /><br />
                  </div>
                  <div class="col-md-12">
                    <span class="p-text-grey">
                      E-mail:&nbsp;
                      <span class="value">{{
                        boobleModalData?.corporateAccount?.users[0]
                        .emailList ||
                        boobleModalData?.corporateAccount?.users[0].email
                        }}
                      </span></span><br /><br />
                  </div>
                </div>
                <div *ngIf="this.boobleModalData?.tipoPessoa == 'PF'" class="row">
                  <div class="col-md-6">
                    <span class="p-text-grey">
                      Nome:&nbsp;
                      <span class="value">{{ this.boobleModalData?.individualAccount?.name }}
                      </span></span><br /><br />
                    <span class="p-text-grey">CPF: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.individualAccount?.cpf
                        | mask : "000.000.000-00"
                        }}</span></span><br /><br />
                  </div>
                  <div class="col-md-6">
                    <span class="p-text-grey">
                      E-mail:&nbsp;
                      <span class="value">{{
                        this.boobleModalData?.individualAccount?.contact
                        ?.email
                        }}
                      </span></span><br /><br />
                    <span class="p-text-grey">
                      Telefone:&nbsp;
                      <span class="value">{{
                        this.boobleModalData?.individualAccount?.contact
                        ?.phone | mask : "(00) 00000-0000 || (00) 0000-0000"
                        }}
                      </span></span><br /><br />
                  </div>
                </div>

                <h4 class="mg-bottom-32 mg-top-8 title-generic">
                  Dados do pagador
                </h4>
                <div class="row">
                  <div class="col-md-6">
                    <span class="p-text-grey">
                      Nome:&nbsp;
                      <span class="value">{{ this.boobleModalData?.sender?.companyName }}
                      </span></span><br /><br />
                    <span *ngIf="this.boobleModalData?.sender?.email" class="p-text-grey">
                      E-mail:&nbsp;
                      <span class="value">{{ this.boobleModalData?.sender?.email }}
                      </span></span><br /><br />
                  </div>
                  <div class="col-md-6">
                    <span class="p-text-grey">
                      País:&nbsp;
                      <span class="value">{{
                        this.boobleModalData?.sender?.country?.description
                        }}
                      </span></span><br /><br />
                  </div>
                </div>

                <ng-container *ngIf="this.boobleModalData?.quotations[0]">
                  <h4 class="mg-bottom-32 mg-top-8 title-generic">
                    Dados do fechamento de câmbio
                  </h4>
                  <div class="row">
                    <div class="col-md-6">
                      <span class="p-text-grey">
                        Câmbio com spread:&nbsp;
                        <span class="value">R${{
                          commercial?.toString().replace(".", ",")
                          }}</span></span><br /><br />

                      <span class="p-text-grey">Tarifa: &nbsp;
                        <span class="value">
                          {{
                          this.boobleModalData?.quotations[0]?.tariff | brl
                          }}
                        </span></span><br /><br />
                      <span class="p-text-grey">Valor em reais: &nbsp;
                        <span class="value">
                          {{
                          this.boobleModalData?.quotations[0]?.amountMN | brl
                          }}
                        </span></span><br /><br />
                    </div>
                    <div class="col-md-6">
                      <ng-container *ngIf="boobleModalData?.quotations[0]?.id">
                        <span class="p-text-grey">
                          Câmbio comercial:&nbsp;
                          <span class="value">R${{
                            this.boobleModalData?.quotations[0]?.rate
                            ?.toString()
                            .replace(".", ",")
                            }}</span></span><br /><br />
                        <span class="p-text-grey">IOF ({{ iof * 100 | number : "1.2-2" }}%): &nbsp;
                          <span class="value">{{
                            commercial * this.boobleModalData?.amount * iof
                            | brl
                            }}
                          </span></span><br /><br />
                        <span class="p-text-grey">
                          Imposto de renda ({{ ir * 100 }}%): &nbsp;
                          <span class="value">{{
                            getIr(
                            this.boobleModalData?.quotations[0]?.rate,
                            this.boobleModalData?.quotations[0]?.spread,
                            ir,
                            this.boobleModalData?.quotations[0]?.ptax
                            ) | brl
                            }}</span></span><br /><br />
                        <span class="p-text-grey">
                          Valor efetivo total: &nbsp;
                          <span class="value">{{
                            1
                            | currency
                            : this.boobleModalData?.currency?.description
                            }}
                            =
                            {{
                            this.boobleModalData?.quotations[0]?.vet | brl
                            }}</span></span><br /><br />
                      </ng-container>
                    </div>
                  </div>
                </ng-container>
              </div>
              <div *ngIf="!showReadMore" class="d-flex justify-content-center">
                <span (click)="
                    !showReadMore
                      ? (showReadMore = true)
                      : (showReadMore = false)
                  " class="view-more">{{ showReadMore ? "Ver mais " : "Ver menos" }}</span>
              </div>
            </div>

            <div *ngIf="boobleModalData.remmitanceType === 'OUTBOUND'" class="box-order">
              <div class="row">
                <div class="col-md-6">
                  <span class="p-text-grey">
                    Número:&nbsp;
                    <span class="value">{{ this.boobleModalData?.id }}
                    </span></span><br /><br />
                  <span class="p-text-grey">Moeda: &nbsp;
                    <span class="value">
                      <mat-icon [svgIcon]="this.currency?.icon"></mat-icon><span class="ml-2">{{
                        this.currency?.description
                        }}</span>
                    </span></span><br /><br />
                  <span class="p-text-grey">
                    Valor de destino:&nbsp;
                    <span class="value">{{ this.boobleModalData?.currency?.description }}
                      {{ this.boobleModalData?.amount | amountPipe }}</span></span><br /><br />

                  <span class="p-text-grey">
                    Modalidade:&nbsp;
                    <span class="value">{{
                      getModalityText(this.boobleModalData?.modality)
                      }}</span></span><br /><br />
                </div>

                <div class="col-md-6">
                  <span class="p-text-grey">Data de criação: &nbsp;
                    <span class="value">{{
                      this.boobleModalData?.createdDate | date : "dd/MM/yyyy"
                      }}</span></span><br /><br />

                  <span class="p-text-grey">
                    Finalidade:&nbsp;
                    <span class="value">{{ this.boobleModalData?.finality?.description }}
                    </span></span><br /><br />
                  <span class="p-text-grey">
                    Valor em reais:&nbsp;
                    <span class="value-bold">
                      {{ this.boobleModalData?.quotations[0]?.amountMN | brl }}
                    </span></span><br /><br />
                </div>
              </div>

              <div class="d-flex justify-content-center" *ngIf="showReadMore">
                <span (click)="
                    !showReadMore
                      ? (showReadMore = true)
                      : (showReadMore = false)
                  " class="view-more">{{ showReadMore ? "Ver mais " : "Ver menos" }}</span>
              </div>

              <div [class]="showReadMore ? 'd-none' : 'd-block'">
                <h4 class="mg-bottom-32 mg-top-8 title-generic">
                  Dados do cliente
                </h4>
                <div *ngIf="this.boobleModalData?.tipoPessoa == 'PJ'" class="row">
                  <div class="col-md-6">
                    <span class="p-text-grey">
                      Nome:&nbsp;
                      <span class="value">{{
                        this.boobleModalData?.corporateAccount?.companyName
                        }}
                      </span></span><br /><br />
                    <span class="p-text-grey">CNPJ: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.corporateAccount?.cnpj
                        | mask : "AA.AAA.AAA/AAAA-00"
                        }}</span></span><br /><br />
                  </div>
                  <div class="col-md-6">
                    <span class="p-text-grey">
                      Telefone:&nbsp;
                      <span class="value">{{
                        this.boobleModalData?.corporateAccount?.users[0]
                        ?.phoneNumber
                        | mask : "(00) 00000-0000 || (00) 0000-0000"
                        }}
                      </span></span><br /><br />
                    <span class="p-text-grey">
                      Faturamento anual:&nbsp;
                      <span class="value">
                        {{
                        this.boobleModalData?.corporateAccount?.annualBilling
                        | brl
                        }}
                      </span></span><br /><br />
                  </div>
                  <div class="col-md-12">
                    <span class="p-text-grey">
                      E-mail:&nbsp;
                      <span class="value">{{
                        boobleModalData?.corporateAccount?.users[0]
                        .emailList ||
                        boobleModalData?.corporateAccount?.users[0].email
                        }}
                      </span></span><br /><br />
                  </div>
                </div>
                <div *ngIf="this.boobleModalData?.tipoPessoa == 'PF'" class="row">
                  <div class="col-md-6">
                    <span class="p-text-grey">
                      Nome:&nbsp;
                      <span class="value">{{ this.boobleModalData?.individualAccount?.name }}
                      </span></span><br /><br />
                    <span class="p-text-grey">CPF: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.individualAccount?.cpf
                        | mask : "000.000.000-00"
                        }}</span></span><br /><br />
                  </div>
                  <div class="col-md-6">
                    <span class="p-text-grey">
                      E-mail:&nbsp;
                      <span class="value">{{
                        this.boobleModalData?.individualAccount?.contact
                        ?.email
                        }}
                      </span></span><br /><br />
                    <span class="p-text-grey">
                      Telefone:&nbsp;
                      <span class="value">{{
                        this.boobleModalData?.individualAccount?.contact
                        ?.phone | mask : "(00) 00000-0000 || (00) 0000-0000"
                        }}
                      </span></span><br /><br />
                  </div>
                </div>

                <h4 class="mg-bottom-32 mg-top-8 title-generic">
                  Dados do recebedor
                </h4>
                <div class="row">
                  <div class="col-md-6">
                    <span class="p-text-grey">
                      Nome:&nbsp;
                      <span class="value">{{ this.boobleModalData?.receiver?.name }}
                      </span></span><br /><br />
                    <span class="p-text-grey">Banco: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.receiver?.receiverAccount?.bank ||
                        this.boobleModalData?.receiver?.bankName
                        }}</span></span><br /><br />
                    <ng-container *ngIf="
                        this.boobleModalData?.receiver?.receiverAccount
                          ?.number || this.boobleModalData?.receiver?.account
                      ">
                      <span class="p-text-grey">Conta: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.receiverAccount
                          ?.number || this.boobleModalData?.receiver?.account
                          }}</span></span><br /><br />
                    </ng-container>
                    <ng-container *ngIf="
                        this.boobleModalData?.receiver?.receiverAccount
                          ?.institutionNumber
                      ">
                      <span class="p-text-grey">Institution Number: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.receiverAccount
                          ?.institutionNumber
                          }}</span></span><br /><br />
                    </ng-container>

                    <ng-container *ngIf="
                        this.boobleModalData?.receiver?.receiverAccount?.transit
                      ">
                      <span class="p-text-grey">Transit: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.receiverAccount
                          ?.transit
                          }}</span></span><br /><br />
                    </ng-container>

                    <ng-container *ngIf="
                        this.boobleModalData?.receiver?.receiverAccount?.address
                      ">
                      <span class="p-text-grey">Address: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.receiverAccount
                          ?.address
                          }}</span></span><br /><br />
                    </ng-container>
                    <ng-container *ngIf="
                        this.boobleModalData?.receiver?.receiverAccount?.cbu
                      ">
                      <span class="p-text-grey">CBU: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.receiverAccount?.cbu
                          }}</span></span><br /><br />
                    </ng-container>
                    <ng-container *ngIf="
                        this.boobleModalData?.receiver?.receiverAccount
                          ?.sortCode
                      ">
                      <span class="p-text-grey">Sort Code: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.receiverAccount
                          ?.sortCode
                          }}</span></span><br /><br />
                    </ng-container>
                  </div>

                  <div class="col-md-6">
                    <span class="p-text-grey">
                      País:&nbsp;
                      <span class="value">{{
                        this.boobleModalData?.receiver?.country?.description
                        }}
                      </span></span><br /><br />
                    <span class="p-text-grey">Código SWIFT: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.receiver?.receiverAccount
                        ?.swift || this.boobleModalData?.receiver?.swift
                        }}</span></span><br /><br />
                    <ng-container *ngIf="
                        this.boobleModalData?.receiver?.receiverAccount?.aba
                      ">
                      <span class="p-text-grey">ABA: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.receiverAccount?.aba
                          }}</span></span><br /><br />
                    </ng-container>

                    <ng-container *ngIf="
                        this.boobleModalData?.receiver?.receiverAccount?.iban
                      ">
                      <span class="p-text-grey">IBAN: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.receiverAccount?.iban
                          }}</span></span><br /><br />
                    </ng-container>

                    <ng-container *ngIf="
                        this.boobleModalData?.receiver?.receiverAccount?.cable
                      ">
                      <span class="p-text-grey">Cable: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.receiverAccount?.cable
                          }}</span></span><br /><br />
                    </ng-container>

                    <ng-container *ngIf="
                        this.boobleModalData?.receiver?.receiverAccount?.blz
                      ">
                      <span class="p-text-grey">BLZ: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.receiverAccount?.blz
                          }}</span></span><br /><br />
                    </ng-container>

                    <ng-container *ngIf="
                        this.boobleModalData?.receiver?.receiverAccount?.fcc
                      ">
                      <span class="p-text-grey">FFC: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.receiverAccount?.fcc
                          }}</span></span><br /><br />
                    </ng-container>

                    <ng-container *ngIf="
                        this.boobleModalData?.receiver?.receiverAccount?.cuit
                      ">
                      <span class="p-text-grey">CUIT: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.receiverAccount?.cuit
                          }}</span></span><br /><br />
                    </ng-container>

                    <ng-container *ngIf="
                        this.boobleModalData?.receiver?.receiverAccount?.bsb
                      ">
                      <span class="p-text-grey">BSB: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.receiverAccount?.bsb
                          }}</span></span><br /><br />
                    </ng-container>
                  </div>
                </div>

                <ng-container *ngIf="
                    this.boobleModalData?.receiver?.intermediaryAccount?.country
                      ?.description
                  ">
                  <h4 class="mg-bottom-32 mg-top-8 title-generic">
                    Dados do banco intermediário
                  </h4>
                  <div class="row">
                    <div class="col-md-6">
                      <span class="p-text-grey">
                        País:&nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.intermediaryAccount
                          ?.country?.description
                          }}
                        </span></span><br /><br />
                      <span class="p-text-grey">Banco: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.intermediaryAccount
                          ?.bank
                          }}</span></span><br /><br />
                      <ng-container *ngIf="
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.number
                        ">
                        <span class="p-text-grey">Conta: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.receiver?.intermediaryAccount
                            ?.number
                            }}</span></span><br /><br />
                      </ng-container>
                      <ng-container *ngIf="
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.institutionNumber
                        ">
                        <span class="p-text-grey">Institution Number: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.receiver?.intermediaryAccount
                            ?.institutionNumber
                            }}</span></span><br /><br />
                      </ng-container>

                      <ng-container *ngIf="
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.transit
                        ">
                        <span class="p-text-grey">Transit: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.receiver?.intermediaryAccount
                            ?.transit
                            }}</span></span><br /><br />
                      </ng-container>

                      <ng-container *ngIf="
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.address
                        ">
                        <span class="p-text-grey">Address: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.receiver?.intermediaryAccount
                            ?.address
                            }}</span></span><br /><br />
                      </ng-container>

                      <ng-container *ngIf="
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.cbu
                        ">
                        <span class="p-text-grey">CBU: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.receiver?.intermediaryAccount
                            ?.cbu
                            }}</span></span><br /><br />
                      </ng-container>

                      <ng-container *ngIf="
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.sortCode
                        ">
                        <span class="p-text-grey">Sort Code: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.receiver?.intermediaryAccount
                            ?.sortCode
                            }}</span></span><br /><br />
                      </ng-container>
                    </div>
                    <div class="col-md-6">
                      <ng-container>
                        <span class="p-text-grey">Cidade: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.receiver?.intermediaryAccount
                            ?.city
                            }}</span></span><br /><br />
                      </ng-container>
                      <span class="p-text-grey">
                        Código SWIFT: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.receiver?.intermediaryAccount
                          ?.swift
                          }}
                        </span></span><br /><br />

                      <ng-container *ngIf="
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.aba
                        ">
                        <span class="p-text-grey">ABA: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.receiver?.intermediaryAccount
                            ?.aba
                            }}</span></span><br /><br />
                      </ng-container>

                      <ng-container *ngIf="
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.iban
                        ">
                        <span class="p-text-grey">IBAN: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.receiver?.intermediaryAccount
                            ?.iban
                            }}</span></span><br /><br />
                      </ng-container>

                      <ng-container *ngIf="
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.cable
                        ">
                        <span class="p-text-grey">Cable: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.receiver?.intermediaryAccount
                            ?.cable
                            }}</span></span><br /><br />
                      </ng-container>
                      <ng-container *ngIf="
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.blz
                        ">
                        <span class="p-text-grey">BLZ: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.receiver?.intermediaryAccount
                            ?.blz
                            }}</span></span><br /><br />
                      </ng-container>
                      <ng-container *ngIf="
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.fcc
                        ">
                        <span class="p-text-grey">FFC: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.receiver?.intermediaryAccount
                            ?.fcc
                            }}</span></span><br /><br />
                      </ng-container>
                      <ng-container *ngIf="
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.cuit
                        ">
                        <span class="p-text-grey">CUIT: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.receiver?.intermediaryAccount
                            ?.cuit
                            }}</span></span><br /><br />
                      </ng-container>
                      <ng-container *ngIf="
                          this.boobleModalData?.receiver?.intermediaryAccount
                            ?.bsb
                        ">
                        <span class="p-text-grey">BSB: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.receiver?.intermediaryAccount
                            ?.bsb
                            }}</span></span><br /><br />
                      </ng-container>
                    </div>
                  </div>
                </ng-container>

                <h4 class="mg-bottom-32 mg-top-8 title-generic">
                  Dados do fechamento de câmbio
                </h4>
                <div class="row">
                  <div class="col-md-6">
                    <span class="p-text-grey">
                      Opção de envio:&nbsp;
                      <span *ngIf="
                          boobleModalData?.quotations[0]?.deliveryOption ===
                          'SWIFT'
                        " class="value">Envio tradicional (SWIFT)
                      </span>
                      <span *ngIf="
                          boobleModalData?.quotations[0]?.deliveryOption ===
                          'NIUM'
                        " class="value">Envio por Remessadora (NIUM)
                      </span></span><br /><br />
                    <ng-container *ngIf="this.boobleModalData?.settlementFlowTreasury">
                      <span class="p-text-grey">Fluxo de liquidação: &nbsp;
                        <span class="value">{{
                          this.boobleModalData?.settlementFlowTreasury
                          }}</span></span><br /><br />
                    </ng-container>
                    <span class="p-text-grey">
                      Câmbio com spread:&nbsp;
                      <span class="value">R${{ commercial?.toString().replace(".", ",") }}</span></span><br /><br />
                    <span class="p-text-grey">Tarifa: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.quotations[0]?.tariff | brl
                        }}</span></span><br /><br />
                    <span class="p-text-grey">Valor em reais: &nbsp;
                      <span class="value">{{
                        this.boobleModalData?.quotations[0]?.amountMN | brl
                        }}</span></span><br /><br />
                  </div>
                  <div class="col-md-6">
                    <ng-container *ngIf="boobleModalData?.quotations[0]?.id">
                      <span class="p-text-grey">IOF ({{ iof * 100 | number : "1.2-2" }}%): &nbsp;
                        <span class="value">{{
                          commercial * this.boobleModalData?.amount * iof | brl
                          }}</span></span><br /><br />
                      <span class="p-text-grey">
                        Imposto de renda ({{ ir * 100 }}%): &nbsp;
                        <span class="value">{{
                          getIr(
                          this.boobleModalData?.quotations[0]?.rate,
                          this.boobleModalData?.quotations[0]?.spread,
                          ir,
                          this.boobleModalData?.quotations[0]?.ptax
                          ) | brl
                          }}</span></span><br /><br />
                      <span class="p-text-grey">
                        Câmbio comercial:&nbsp;
                        <span class="value">R${{
                          this.boobleModalData?.quotations[0]?.rate
                          ?.toString()
                          .replace(".", ",")
                          }}</span></span><br /><br />
                      <span class="p-text-grey">
                        Valor efetivo total: &nbsp;
                        <span class="value">{{
                          1
                          | currency
                          : this.boobleModalData?.currency?.description
                          }}
                          =
                          {{
                          this.boobleModalData?.quotations[0]?.vet | brl
                          }}</span></span><br /><br />
                    </ng-container>
                  </div>
                </div>

                <ng-container *ngIf="this.boobleModalData?.bankCurrencyTreasury">
                  <h4 class="mg-bottom-32 mg-top-8 title-generic">
                    Dados da tesouraria
                  </h4>
                  <div class="row">
                    <div class="col-md-6">
                      <span class="p-text-grey">
                        Origem da moeda:&nbsp;
                        <span class="value">{{ this.boobleModalData?.bankCurrencyTreasury }}
                        </span></span><br /><br />
                      <ng-container *ngIf="this.boobleModalData?.settlementFlowTreasury">
                        <span class="p-text-grey">Fluxo de liquidação: &nbsp;
                          <span class="value">{{
                            this.boobleModalData?.settlementFlowTreasury
                            }}</span></span><br /><br />
                      </ng-container>
                    </div>
                    <div class="col-md-6">
                      <span class="p-text-grey">
                        Taxa de nivelamento:&nbsp;
                        <span class="value">R${{ this.boobleModalData?.levelingRateTreasury }}
                        </span></span><br /><br />
                    </div>
                  </div>
                </ng-container>
              </div>

              <div *ngIf="!showReadMore" class="d-flex justify-content-center">
                <span (click)="
                    !showReadMore
                      ? (showReadMore = true)
                      : (showReadMore = false)
                  " class="view-more">{{ showReadMore ? "Ver mais " : "Ver menos" }}</span>
              </div>
            </div>
          </div>

          <p class="name">Informações sobre a compra da moeda</p>

          <ng-container *ngIf="boobleModalData.remmitanceType === 'INBOUND'">
            <div [formGroup]="formTreasuryInbound" class="row mt-4 form-bank">
              <div class="col-md-6">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Taxa de nivelamento</mat-label>
                  <input matInput formControlName="LevelingRateTreasury" type="text" currencyMask
                    (keydown)="preventNegative($event)" (input)="
                      ensurePositiveValue('LevelingRateTreasury', formTreasury)
                    " [options]="{
                      prefix: 'R$ ',
                      thousands: '.',
                      decimal: ',',
                      precision: 8
                    }" />

                  <mat-error class="text-danger" *ngIf="
                      formTreasury.controls['LevelingRateTreasury'].touched &&
                      formTreasury.controls['LevelingRateTreasury'].errors
                        ?.required
                    ">
                    Taxa de nivelamento obrigatória
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div [formGroup]="formTreasuryInbound" class="row mt-4">
              <div class="col">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Observação</mat-label>
                  <textarea matInput formControlName="treasuryObservation" rows="3"
                    placeholder="Digite uma observação (opcional)"></textarea>
                </mat-form-field>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="boobleModalData.remmitanceType === 'OUTBOUND'">
            <div [formGroup]="formTreasury" class="row mt-4 form-bank">
              <div class="col-md-4">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Origem da moeda</mat-label>
                  <mat-select formControlName="BankCurrencyTreasury">
                    <ng-container *ngIf="deme$ | async as banks">
                      <mat-option *ngFor="let bank of banks" [value]="bank">{{
                        bank
                        }}</mat-option>
                    </ng-container>
                  </mat-select>
                  <mat-error class="text-danger" *ngIf="
                      formTreasury.controls['BankCurrencyTreasury'].touched &&
                      formTreasury.controls['BankCurrencyTreasury'].errors
                        ?.required
                    ">
                    Origem da moeda obrigatória</mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Taxa de nivelamento</mat-label>
                  <input matInput formControlName="LevelingRateTreasury" type="text" currencyMask
                    (keydown)="preventNegative($event)" (input)="
                      ensurePositiveValue('LevelingRateTreasury', formTreasury)
                    " [options]="{
                      prefix: 'R$ ',
                      thousands: '.',
                      decimal: ',',
                      precision: 8
                    }" />

                  <mat-error class="text-danger" *ngIf="
                      formTreasury.controls['LevelingRateTreasury'].touched &&
                      formTreasury.controls['LevelingRateTreasury'].errors
                        ?.required
                    ">
                    Taxa de nivelamento obrigatória
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="col-md-4">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Fluxo de liquidação</mat-label>
                  <mat-select formControlName="SettlementFlowTreasury">
                    <mat-option value="D0">D0</mat-option>
                    <mat-option value="D+1">D+1</mat-option>
                    <mat-option value="D+2">D+2</mat-option>
                    <mat-option value="Termo D0">Termo D0</mat-option>
                    <mat-option value="Termo D1">Termo D1</mat-option>
                    <mat-option value="Termo D2">Termo D2</mat-option>
                  </mat-select>
                  <mat-error class="text-danger" *ngIf="
                      formTreasury.controls['SettlementFlowTreasury'].touched &&
                      formTreasury.controls['SettlementFlowTreasury'].errors
                        ?.required
                    ">
                    Fluxo de liquidação obrigatório</mat-error>
                </mat-form-field>
              </div>
            </div>

            <div [formGroup]="formTreasury" class="row">
              <div class="col-md-12">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Observação</mat-label>
                  <textarea matInput formControlName="treasuryObservation" rows="3"
                    placeholder="Digite uma observação (opcional)"></textarea>
                </mat-form-field>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="modal-footer-new" [style.justify-content]="'space-between'">
        <button type="button" [style.width]="'134px'" class="btn-outline-dark btn" (click)="closeModal()" type="button">
          Fechar
        </button>
        <button type="button" class="btn-footer btn btn-dark-primary-blue" [disabled]="
            boobleModalData?.remmitanceType == 'INBOUND'
              ? formTreasuryInbound.invalid || loading
              : formTreasury.invalid || loading
          " (click)="sendTreasury()" type="button">
          Confirmar
          <span class="spinner-border spinner-border-sm" *ngIf="loading"></span>
        </button>
      </div>
    </div>
  </div>
</div>